"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT = exports.VIEW_OPTIONS = exports.KIND = exports.PHONE_COLORS = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const next_utils_front_sonda_1 = __importDefault(require("@gerenciatd/next.utils.front-sonda"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_components_text_info_1 = __importDefault(require("@gerenciatd/next.components.text-info"));
const next_components_button_n_1 = __importDefault(require("@gerenciatd/next.components.button-n"));
const next_components_icon_1 = __importDefault(require("@gerenciatd/next.components.icon"));
const enums_1 = require("./enums");
Object.defineProperty(exports, "PHONE_COLORS", { enumerable: true, get: function () { return enums_1.PHONE_COLORS; } });
Object.defineProperty(exports, "KIND", { enumerable: true, get: function () { return enums_1.KIND; } });
Object.defineProperty(exports, "VIEW_OPTIONS", { enumerable: true, get: function () { return enums_1.VIEW_OPTIONS; } });
Object.defineProperty(exports, "SEGMENT", { enumerable: true, get: function () { return enums_1.SEGMENT; } });
/**
 * @name Call4Selling
 * @param {any} props
 * @param {React.Ref} ref
 * @returns {React.FC}
 */
const Call4Selling = ({ forced900, applySam, activateCML, kind, taggingInfo, buttonProps, view, label, innerLabel, print900, className, textProps, innerLabelTextProps, phoneTextProps, children, iconProps, forceExternal, }) => {
    const [isSCXLoaded, setIsSCXLoaded] = (0, react_1.useState)(0);
    const [virtual900, setVirtual900] = (0, react_1.useState)('');
    const [lastComunicated, setLastComunicated] = (0, react_1.useState)('');
    const myTaggingInfo = Object.assign({ componentName: 'Call4Selling', componentContent: kind, componentProduct: '', componentVariation: 'all' }, taggingInfo);
    const get900 = () => {
        if (forced900) {
            return forced900;
        }
        return window.SCX.get900();
    };
    const checkAndSubscribeToSCX = () => {
        var _a;
        (_a = window.nookInfoExchange) === null || _a === void 0 ? void 0 : _a.registerAsObserver('SCX-Status', `Call4Selling_${Math.random()}`, () => {
            if (kind === enums_1.KIND.PHONE) {
                const phone = get900();
                if (phone !== virtual900) {
                    setVirtual900(get900());
                }
            }
            else {
                window.SCX.setReactEnviroment();
            }
        });
        if (window && window.SCX) {
            setIsSCXLoaded(1);
        }
        else {
            document.addEventListener('SCX_CREATED', () => {
                setIsSCXLoaded(isSCXLoaded + 1);
            });
        }
    };
    const comunicate900Printed = (num900) => {
        if (lastComunicated !== num900) {
            setLastComunicated(num900);
            window.SCX.comunicate900Printed(num900);
        }
    };
    const handleClick = () => {
        if (window.SCX && window.SCX.processC2C) {
            window.SCX.launchModalC2C();
        }
        else {
            // Sonda esto
            const sonda = new next_utils_front_sonda_1.default({
                processName: 'launchModalC2C',
                context: null,
                filePath: 'call4SellingComponent',
            });
            sonda.warningMessage({
                info: 'No se ha podido lanzar la modal C2C',
            });
        }
    };
    (0, react_1.useEffect)(() => {
        const loadjs = require('loadjs');
        const scxRoute = process.env.NEXT_PUBLIC_ENV_NAME === 'prod'
            ? enums_1.SCX_ROUTE.PROD
            : enums_1.SCX_ROUTE.QA;
        // Si voy a necesitar scx.js, lo incluyo!
        if (((kind === enums_1.KIND.PHONE && !forced900) || kind === enums_1.KIND.C2C) &&
            !window.SCX) {
            loadjs(scxRoute, { async: true });
        }
        if (applySam &&
            typeof window !== 'undefined' &&
            typeof window.IC !== 'undefined' &&
            typeof window.IC.evaluate === 'function') {
            if (typeof window.sa2mAction === 'undefined') {
                window.IC.evaluate('SCX', () => {
                    if (typeof window.sa2mAction === 'undefined') {
                        window.sa2mAction = { 900: 'show', c2c: 'show' };
                    }
                }, () => {
                    if (typeof window.sa2mAction === 'undefined') {
                        window.sa2mAction = { 900: 'show', c2c: 'show' };
                    }
                });
            }
        }
        checkAndSubscribeToSCX();
    }, []);
    if (typeof window !== 'undefined') {
        if (typeof window.SCX !== 'undefined') {
            if (kind === enums_1.KIND.PHONE) {
                if (!virtual900 ||
                    !window.SCX.CMNTimeTableValid() ||
                    (applySam &&
                        typeof window.sa2mAction !== 'undefined' &&
                        window.sa2mAction['900'] === 'hide')) {
                    return null;
                }
                comunicate900Printed(get900());
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    view === enums_1.VIEW_OPTIONS.BUTTON && label && (react_1.default.createElement(next_components_button_n_1.default, Object.assign({ className: `${className} call4selling call4Selling_button call4selling_phone`, label: print900 ? `${label} ${virtual900}` : `${label}`, href: `tel:${virtual900}`, taggingInfo: myTaggingInfo, forceExternal: forceExternal }, buttonProps))),
                    view === enums_1.VIEW_OPTIONS.PHONE && label && (react_1.default.createElement(next_components_text_info_1.default, Object.assign({ text: label }, textProps))),
                    view === enums_1.VIEW_OPTIONS.PHONE && (react_1.default.createElement(next_components_custom_link_1.default, { href: `tel:${virtual900}`, className: `${className} call4selling call4selling_phone scx-telefono`, taggingInfo: myTaggingInfo, title: `${innerLabel ? `${innerLabel} ` : 'Llamar gratis al '}${virtual900}`, ariaLabel: virtual900, forceExternal: forceExternal },
                        innerLabel && (react_1.default.createElement(next_components_text_info_1.default, Object.assign({ text: `${innerLabel} ` }, innerLabelTextProps))),
                        react_1.default.createElement(next_components_text_info_1.default, Object.assign({ text: virtual900 }, phoneTextProps)),
                        react_1.default.createElement(next_components_icon_1.default, Object.assign({}, iconProps))))));
            }
            if (kind === enums_1.KIND.C2C &&
                (window.SCX.CMNTimeTableValid() || activateCML) &&
                !(applySam &&
                    typeof window.sa2mAction !== 'undefined' &&
                    window.sa2mAction.c2c === 'hide')) {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    view === enums_1.VIEW_OPTIONS.PHONE && (react_1.default.createElement(next_components_custom_link_1.default, { onClick: handleClick, className: `call4selling call4selling_c2c ${className}`, taggingInfo: myTaggingInfo, title: "Te llamamos", ariaLabel: "Te llamamos", forceExternal: forceExternal }, children)),
                    view === enums_1.VIEW_OPTIONS.BUTTON && (react_1.default.createElement(next_components_button_n_1.default, Object.assign({ className: `call4selling call4selling_c2c ${className}`, onClick: handleClick, taggingInfo: myTaggingInfo, forceExternal: forceExternal }, buttonProps)))));
            }
            return null;
        }
    }
    return null;
};
Call4Selling.propTypes = {
    /**
     * {
     *  "info": "Activar activateCallMeLater (CML)",
     *  "kind": "playground",
     *  "beautifulName": "Call Me Later"
     * }
     */
    activateCML: prop_types_1.default.bool,
    /**
     * {
     *  "info": "Activar acciones SAM",
     *  "kind": "both",
     *  "beautifulName": "SAM"
     * }
     */
    applySam: prop_types_1.default.bool,
    /**
     * {
     *  "info": "Mostrar barra 900",
     *  "kind": "both",
     *  "beautifulName": "900"
     * }
     */
    print900: prop_types_1.default.bool,
    /**
     * {
     *  "info": "Segmento para definir carta de colores correspondiente",
     *  "kind": "both",
     *  "beautifulName": "segment"
     * }
     */
    segment: prop_types_1.default.oneOf([enums_1.SEGMENT.GP, enums_1.SEGMENT.EMP]),
    /**
     * {
     *  "info": "Define la clase CSS custom que se aplicará al componente",
     *  "kind": "both",
     *  "beautifulName": "Estilos custom"
     * }
     */
    className: prop_types_1.default.string,
    /**
     * {
     *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
     *  "kind": "both",
     *  "beautifulName": "Propiedades tagueo"
     * }
     */
    taggingInfo: prop_types_1.default.object,
    /**
     * {
     *  "info": "Definición de las propiedades para el TextInfo que precede al número de teléfono, POR DEFECTO es un span",
     *  "kind": "both",
     *  "beautifulName": "Propiedades botón"
     * }
     */
    textProps: prop_types_1.default.object,
    /**
     * {
     *  "info": "Definición de las propiedades para el TextInfo que acompaña al número de teléfono, POR DEFECTO es un span",
     *  "kind": "both",
     *  "beautifulName": "Propiedades label"
     * }
     */
    innerLabelTextProps: prop_types_1.default.object,
    /**
     * {
     *  "info": "Definición de las propiedades para el TextInfo que representa al número de teléfono, POR DEFECTO es un span",
     *  "kind": "both",
     *  "beautifulName": "Propiedades del texto del telefono"
     * }
     */
    phoneTextProps: prop_types_1.default.object,
    /**
     * {
     *  "info": "Definición de las propiedades para el botón",
     *  "kind": "both",
     *  "beautifulName": "Propiedades telefono"
     * }
     */
    buttonProps: prop_types_1.default.object,
    /**
     * {
     *  "info": "Definición de las propiedades para el icono",
     *  "kind": "both",
     *  "beautifulName": "Propiedades icono"
     * }
     */
    iconProps: prop_types_1.default.object,
    /**
     * {
     *  "info": "Visibiliza el componente",
     *  "kind": "both",
     *  "beautifulName": "Visible"
     * }
     */
    view: prop_types_1.default.oneOf([enums_1.VIEW_OPTIONS.BUTTON, enums_1.VIEW_OPTIONS.PHONE]),
    /**
     * {
     *  "info": "número 900 'a fuego' que se quiere pintar",
     *  "kind": "both",
     *  "beautifulName": "forced900"
     * }
     */
    forced900: prop_types_1.default.string,
    /**
     * {
     *  "info": "tipo de C4S",
     *  "kind": "both",
     *  "beautifulName": "kind"
     * }
     */
    kind: prop_types_1.default.oneOf([enums_1.KIND.C2C, enums_1.KIND.PHONE]),
    forceExternal: prop_types_1.default.bool,
};
Call4Selling.defaultProps = {
    className: '',
    segment: enums_1.SEGMENT.GP,
    applySam: true,
    print900: true,
    view: enums_1.VIEW_OPTIONS.PHONE,
    kind: enums_1.KIND.PHONE,
    activateCML: false,
    textProps: {},
    innerLabelTextProps: {},
    phoneTextProps: {},
    buttonProps: {},
    forced900: '',
    taggingInfo: {},
    iconProps: {},
    forceExternal: false,
};
exports.default = Call4Selling;
//# sourceMappingURL=index.js.map